import { scrollIntoView } from '@/utils/scroll-into-view';
import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { onMounted, onUnmounted } from 'vue';

export const useKeyboardSettings = () => {
  onMounted(() => {
    if (!Capacitor.isPluginAvailable('Keyboard') || !Capacitor.isNativePlatform()) return;
    Keyboard.setAccessoryBarVisible({ isVisible: true });
    Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    Keyboard.setScroll({
      isDisabled: false,
    });
    Keyboard.addListener('keyboardDidShow', () => {
      const activeElement = document.activeElement;
      if (!activeElement) {
        return;
      }
      scrollIntoView(activeElement, {});
    });
  });

  onUnmounted(() => {
    if (!Capacitor.isPluginAvailable('Keyboard') || !Capacitor.isNativePlatform()) return;
    Keyboard.removeAllListeners();
  });
};
